import { NavLink } from 'react-router-dom';
import { motion } from 'framer-motion';
import { cn } from '@/utils/cn';

interface Tab {
  to: string;
  label: string;
  icon: string;
}

const TABS: Tab[] = [
  { to: '/', label: '首页', icon: '●' },
  { to: '/todos', label: '待办', icon: '◎' },
  { to: '/organize', label: '整理', icon: '◐' },
  { to: '/profile', label: '我的', icon: '○' },
];

export function TabBar() {
  return (
    <motion.nav
      initial={{ y: 40, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ type: 'spring', damping: 28, stiffness: 260 }}
      className="fixed bottom-0 inset-x-0 z-20 glass border-t border-border"
    >
      <div className="pointer-events-none absolute -top-px inset-x-0 h-px bg-gradient-to-r from-transparent via-accent/40 to-transparent" />
      <ul className="mx-auto max-w-3xl flex">
        {TABS.map((t) => (
          <li key={t.to} className="flex-1">
            <NavLink
              to={t.to}
              end={t.to === '/'}
              className={({ isActive }) =>
                cn(
                  'relative flex flex-col items-center gap-0.5 py-2.5 text-[10px] transition-colors',
                  isActive ? 'text-fg' : 'text-fg-subtle hover:text-fg'
                )
              }
            >
              {({ isActive }) => (
                <>
                  {isActive && (
                    <motion.span
                      layoutId="tab-indicator"
                      className="absolute top-1 h-1 w-8 rounded-full bg-gradient-to-r from-accent to-accent-2"
                      transition={{ type: 'spring', damping: 26, stiffness: 300 }}
                    />
                  )}
                  <span className={cn('text-lg leading-none', isActive && 'text-gradient')}>{t.icon}</span>
                  <span>{t.label}</span>
                </>
              )}
            </NavLink>
          </li>
        ))}
      </ul>
    </motion.nav>
  );
}
